import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Films from "./components/Films";
import DetailFilm from "./components/DetailFilm";
import LecteurFilm from "./components/LecteurFilm";
import "./App.css";

const About = () => (
  <div className="about-container">
    <div className="about-hero">
      <p className="about-kicker">Notre manifeste cinéma</p>
      <h2 className="about-title">À propos de ZéroLimite</h2>
      <p className="about-description">
        ZéroLimite est un repaire cinéphile pensé pour aller droit au but : des films
        qui comptent, des sorties à suivre, et des classiques à redécouvrir. L’idée
        n’est pas de tout lister, mais de t’orienter vite vers le bon choix, avec
        des sélections claires et une interface fluide.
      </p>
    </div>
    <div className="about-grid">
      <div className="about-card">
        <h3>Découverte ciblée</h3>
        <p>
          Tendances, tops du mois, prochaines sorties… Chaque section a un rôle
          précis pour que ton scroll reste utile et inspirant.
        </p>
      </div>
      <div className="about-card">
        <h3>Focus sur la qualité</h3>
        <p>
          Nous mettons en avant les films plébiscités et les incontournables, sans
          te noyer sous des dizaines de variantes identiques.
        </p>
      </div>
      <div className="about-card">
        <h3>Une base solide</h3>
        <p>
          Les fiches sont enrichies avec des infos fiables et des visuels soignés,
          pour te donner envie en un regard.
        </p>
      </div>
    </div>
    <div className="about-meta">
      <div className="about-block">
        <h4>Sources</h4>
        <p>
          Les données proviennent de TMDB (The Movie Database), une référence
          mondiale pour les informations cinéma.
        </p>
      </div>
      <div className="about-block">
        <h4>Ce qui arrive</h4>
        <p>
          Bientôt : recommandations affinées, playlists personnalisées et nouvelles
          sélections éditoriales pour affiner tes découvertes.
        </p>
      </div>
    </div>
  </div>
);

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const scrollToTarget = () => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    const timer = setTimeout(scrollToTarget, 0);
    return () => clearTimeout(timer);
  }, [hash, pathname]);

  return null;
};

export default function App() {
  const [navOpen, setNavOpen] = useState(false);

  const scrollToSearch = () => {
    const searchBar = document.getElementById("search-bar");
    if (searchBar) searchBar.scrollIntoView({ behavior: "smooth", block: "start" });
    setNavOpen(false);
  };
  // Derive basename from PUBLIC_URL so router works when served from a subpath
  const getBasename = () => {
    const pub = process.env.PUBLIC_URL || "";
    if (!pub) return "/";
    try {
      if (pub.startsWith("http")) {
        return new URL(pub).pathname.replace(/\/$/, "") || "/";
      }
    } catch (e) {
      // fall through
    }
    return pub.replace(/\/$/, "") || "/";
  };
  const basename = getBasename();

  return (
    <BrowserRouter basename={basename}>
      <ScrollToHash />
      <header className="site-header">
        <div className="nav-shell">
          <Link to="/" className="brand" onClick={() => setNavOpen(false)}>
            <img
              className="brand-logo"
              src={`${process.env.PUBLIC_URL}/favicon.png`}
              alt="ZéroLimite"
            />
            <span className="brand-name">ZéroLimite</span>
          </Link>
          <button
            className="nav-toggle"
            type="button"
            aria-label="Ouvrir le menu"
            onClick={() => setNavOpen((open) => !open)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <nav className={`nav-links ${navOpen ? "is-open" : ""}`}>
            <Link to="/#tendances" onClick={() => setNavOpen(false)}>Tendances</Link>
            <Link to="/#top10" onClick={() => setNavOpen(false)}>Top 10 du mois</Link>
            <Link to="/#anciens" onClick={() => setNavOpen(false)}>Classiques</Link>
            <Link to="/#sorties-bientot" onClick={() => setNavOpen(false)}>Prochaines sorties</Link>
            <Link to="/about" onClick={() => setNavOpen(false)}>À propos</Link>
            <button onClick={scrollToSearch} className="nav-cta" type="button">
              Chercher un film
            </button>
          </nav>
        </div>
      </header>

      <main className="site-main">
        <Routes>
          <Route path="/" element={<Films />} />
          <Route path="/detail/:idFilm" element={<DetailFilm />} />
          <Route path="/lecteur/:idFilm" element={<LecteurFilm />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>

      <footer className="site-footer">
        <p>&copy; {new Date().getFullYear()} ZéroLimite – Tous droits réservés.</p>
      </footer>
    </BrowserRouter>
  );
}
